import {fetchBody} from "../../config"
import { toLogout, cleanFetch } from "../apiTools";
import { getToken } from "../../component/Login/Auth";
import { URL_LEAGUE_ADD, URL_LEAGUE_GET_LIST, URL_LEAGUE_GET_DETAIL, URL_LEAGUE_EDIT, URL_LEAGUE_CHECK_NAME, URL_LEAGUE_GET_LIST_ENABLE, URL_LEAGUE_GAMETYPE_GET_LIST } from "../../setup/config_mystat";

export function api_getLeagueList ({mReqLeagueList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqLeagueList, token}), 
      url: URL_LEAGUE_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
export function api_getLeagueListEnable ({success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_LEAGUE_GET_LIST_ENABLE, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addLeague ({isAdd=true, mRespLeague, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespLeague, token}), 
      url: isAdd?URL_LEAGUE_ADD:URL_LEAGUE_EDIT, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getLeagueDetail ({mReqLeagueDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_LEAGUE_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_checkLeagueName ({mRespLeague, success, failure}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespLeague, token}), 
      url: URL_LEAGUE_CHECK_NAME, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}



export function api_getLeagueGameTypeList ({mReqLeagueDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqLeagueDetail, token}), 
      url: URL_LEAGUE_GAMETYPE_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}